export const injectionZones = [
  // Order injection zones
  "order.details.before",
  "order.details.after",
  "order.list.before",
  "order.list.after",
  // Draft order injection zones
  "draft_order.list.before",
  "draft_order.list.after",
  "draft_order.details.before",
  "draft_order.details.after",
  // Customer injection zones
  "customer.details.before",
  "customer.details.after",
  "customer.list.before",
  "customer.list.after",
  // Customer group injection zones
  "customer_group.details.before",
  "customer_group.details.after",
  "customer_group.list.before",
  "customer_group.list.after",
  // Product injection zones
  "product.details.before",
  "product.details.after",
  "product.list.before",
  "product.list.after",
  // Product collection injection zones
  "product_collection.details.before",
  "product_collection.details.after",
  "product_collection.list.before",
  "product_collection.list.after",
  // Price list injection zones
  "price_list.details.before",
  "price_list.details.after",
  "price_list.list.before",
  "price_list.list.after",
  // Discount injection zones
  "discount.details.before",
  "discount.details.after",
  "discount.list.before",
  "discount.list.after",
  // Gift card injection zones
  "gift_card.details.before",
  "gift_card.details.after",
  "gift_card.list.before",
  "gift_card.list.after",
  "custom_gift_card.before",
  "custom_gift_card.after",
  // Login
  "login.before",
  "login.after",
] as const
